import styled from 'styled-components'

import { helpers } from 'styles'

export const LinkDoumentation = styled.a`
	margin-top: 24px;
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: ${helpers.color.text};

	&:hover {
		color: ${helpers.color.secondary};
	}

	margin-bottom: 2px;
	border-bottom: 1px solid ${helpers.color.text};

	> svg {
		height: 20px;
		stroke-width: 1.6;
		margin-bottom: 2px;
	}
`
